import * as React from "react";
import "../../views/Alerts.scss";

//components
import { MenuHeader } from "../Atomics";
import { AlertSettingsItem } from ".";
import CIcon from "@coreui/icons-react";
import { NewAlertType } from ".";

//services
import { getAlerts, getAlertType } from "../../services/alertServices";
import { AlertTypeResponse } from "../../services/types";
import HandleUIError from "../../utils/HandleUIError";
import { CSpinner } from "@coreui/react";

//icons
import { cilPlus } from "@coreui/icons";
import usePermission from "../../hooks/usePermission";
import Pagination from "../Pagination";

interface props {
  search: any;
}

const AlertSettings: React.FC<props> = ({ search }) => {
  const { checkPermission } = usePermission()
  const [visibleNewAlertType, setVisibleNewAlertType] =
    React.useState<boolean>(false);
  const [alerts, setAlerts] = React.useState<AlertTypeResponse[]>();
  const [openedModalFrom, setOpenedModalFrom] = React.useState<number>(1);
  const [selectedAlertType, setSelectedAlertType] = React.useState<string>("");
  const [selectedAlertTypeName, setSelectedAlertTypeName] =
    React.useState<string>("");
  const [selectedAlertTypeColor, setSelectedAlertTypeColor] =
    React.useState<string>("");
  const [alertCategoryType, setAlertCategoryType] = React.useState<any>([]);
  const [alertCategorySound, setAlertCategorySound] = React.useState<any>(0);
  const [alertCategoryIcon, setAlertCategoryIcon] = React.useState<any>([]);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [numberOfPages, setNumberOfPages] = React.useState(0);
  const PAGE_SIZE = 10;

  // const [numberOfPages, setNumberOfPages] = React.useState(0);

  React.useEffect(function () {
    refreshAlerts();
  }, [search]);


  function showModal(
    id: typeof selectedAlertType,
    name: string,
    icon: any,
    type: any,
    color: string,
    notification_sound_id: any,
    openedFrom: number
  ): void {
    openVisibleNewAlertType();
    setOpenedModalFrom(openedFrom);
    setSelectedAlertType(id);
    setSelectedAlertTypeName(name);
    setSelectedAlertTypeColor(color);
    setAlertCategoryType(type);
    setAlertCategorySound(notification_sound_id)
    setAlertCategoryIcon(icon);
  }

  async function refreshAlerts() {
    try {
      const response = await getAlertType(search, currentPage);
      // @ts-ignore
      setAlerts(response.data?.rows);
      // @ts-ignore
      setNumberOfPages(Math.ceil(response?.data?.count / PAGE_SIZE));
    } catch (e) {
      HandleUIError(e);
    }
  }

  React.useEffect(() => {
    refreshAlerts()
  }, [numberOfPages, currentPage, search])

  function showEditModal(
    id: string,
    name: string,
    icon: any,
    type: any,
    color: string,
    notification_sound_id: any,
    openedFrom = 2
  ) {
    showModal(id, name, icon, type, color, notification_sound_id, openedFrom);
  }

  function openVisibleNewAlertType() {
    setVisibleNewAlertType(true);
    setOpenedModalFrom(1);
  }

  function closeVisibleNewAlertType() {
    setVisibleNewAlertType(false);
  }

  console.log("numberOfPages", numberOfPages)

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-2">
        <p className="text-color fs-4 mt-3 mb-2">
          Setup the sequence each type of alert will initiate.
        </p>
        {checkPermission("Create and Edit Setting") && (
          <div
            className="add-icon-container mg-lt add-icon-staff"
            onClick={openVisibleNewAlertType}
          >
            <CIcon icon={cilPlus} size="xl" className="add-icon" />
          </div>
        )}
      </div>
      <MenuHeader className="d-flex justify-content-between">
        <p className="text-color py-3 px-3 w-50">Type</p>
        <p className="text-color py-3 px-3 w-50">Category</p>
        <p className="text-color py-3 px-3 w-50">Is Home Alert</p>
        <p className="text-color py-3 px-3 w-50">Auto Send</p>
        <p className="text-color py-3 px-3 w-50">Immediate Send</p>
        <p className="text-color py-3 px-3 w-50">Hidden</p>
        <p className="text-color py-3 px-3 w-50">Default</p>
      </MenuHeader>

      {alerts ? (
        <>
          {alerts.map((alert) => {
            return (
              <AlertSettingsItem
                alertType={alert}
                key={alert.name}
                alerts={alerts}
                refreshAlerts={refreshAlerts}
                showModal={showEditModal}
                alertId={alert.id.toString()}
              />
            );
          })}
        </>
      ) : (
        <>
          <div className="d-flex justify-content-center mt-4">
            <CSpinner variant="grow" />
          </div>
        </>
      )}


      <div className="mt-3">

        {numberOfPages > 1 && (
          <Pagination
            numberOfPages={numberOfPages}
            setCurrentPage={setCurrentPage}
            currentPage={currentPage}
          />
        )}
      </div>

      {visibleNewAlertType && (
        <NewAlertType
          refreshAlerts={refreshAlerts}
          visible={visibleNewAlertType}
          closeModal={closeVisibleNewAlertType}
          openedFrom={openedModalFrom}
          alertId={selectedAlertType}
          alertName={selectedAlertTypeName}
          alertColor={selectedAlertTypeColor}
          alertCategory={alertCategoryType}
          alertSound={alertCategorySound}
          alertIcon={alertCategoryIcon}
          alerts={alerts}
        />
      )}
    </div>
  );
};

export default AlertSettings;
